export default "/images/module_icons_no_bg_hand.png?2691f3a114c8c09ee297d027ff679c4c";